import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppClickStopPropagationDirective } from './app-click-stop-propagation.directive';

@NgModule({
  declarations: [
    AppClickStopPropagationDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AppClickStopPropagationDirective
  ]
})
export class ClickStopPropagationDirectiveModule { }
